module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 

var group = function () {
    return groups.find(function (g) {
        return g['value'] === groupBy;
    }) || {};
};

var groupTitles = function () {
    return group()['groupTitle'];
};

var groupTitle = function (level) {
    return groupTitles()[level];
};
var subLength = function (arr) {
    var len = 0;
    arr.forEach(function (row) {
        len+=row.length;
    })
    return len;
}

var toHectare = function (value) {
    if (value == null || value === '') {
        return '';
    }

    return _.round(value / 10000, 0);
};

var numFormat = function (num) {
    if (num && num.length)
        num = num.replace('.',',');
    return num;
}

    ; __append("\n\n<div class=\"wh100\">\n    <style>\n        .width-regulator td:nth-child(-n+")
    ; __append(escapeFn(groupTitles().length))
    ; __append(") {\n            width : 11%;\n        }\n        .width-regulator td:nth-child(")
    ; __append(escapeFn(groupTitles().length+1))
    ; __append(") {\n            width : 4%;\n        }\n        .width-regulator thead td,\n        .width-regulator td:nth-child(1){\n            word-wrap:break-word;\n        }\n        .width-regulator tr td {\n            word-wrap: break-word;\n        }")
    ; __append("\n    </style>\n\n\n\n<!--    <table class=\"w100 gl-report__table width-regulator\">-->\n<!--        -->\n<!--    </table>-->\n\n")
    ;  if (groupBy === 'farm') {
    ; __append("\n")
    ; __append( UI.Template.render(templatesFolder + 'GroupByFarms', {data: data, groups: groups, groupBy: groupBy}) )
    ; __append("\n    ")
    ; } else {
    ; __append("\n        ")
    ; __append( UI.Template.render(templatesFolder + 'GroupByDists', {data: data, groups: groups, groupBy: groupBy}) )
    ; __append("\n    ")
    ; }
    ; __append("\n</div>\n")
  }
  return __output.join("");

}